// Открытие Telegram-ссылок с фолбэком для Desktop/macOS.
// На Telegram Desktop openTelegramLink иногда молча не срабатывает —
// тогда мини-апп остаётся открытым и юзеру кажется, что кнопка мертва.
// Ловим это: если через 900мс страница всё ещё видима — пробуем иначе.
export function openTgLink(url: string): void {
  const tg = (window as any).Telegram?.WebApp;

  if (!tg || typeof tg.openTelegramLink !== 'function') {
    window.open(url, '_blank');
    return;
  }

  try {
    tg.ready?.();
    tg.openTelegramLink(url);
  } catch (e) {
    window.open(url, '_blank');
    return;
  }

  // Если сработало — Telegram закроет мини-апп и таймер не отработает.
  setTimeout(() => {
    try {
      if (document.visibilityState === 'visible') {
        if (typeof tg.openLink === 'function') tg.openLink(url);
        else window.open(url, '_blank');
      }
    } catch (e) {
      window.open(url, '_blank');
    }
  }, 900);
}
